<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="8">
        <v-card flat>
          <v-alert
            border="left"
            colored-border
            color="deep-purple accent-4"
            elevation="0"
            style="font-size: 1.2rem; font-weight: 600"
            >Personal Details</v-alert
          >
          <v-row class="ma-0">
            <v-col cols="12" md="2">
              <v-text-field
                hide-details
                outlined
                dense
                label="Title *"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="4">
              <v-text-field
                hide-details
                outlined
                dense
                label="First Name *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                hide-details
                outlined
                dense
                label="Middle Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                hide-details
                outlined
                dense
                label="Last Name *"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="12">
              <v-text-field
                hide-details
                outlined
                dense
                label="Father's Name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Gender *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="DOB *"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Email *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Mobile *"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card flat class="mt-3">
          <v-alert
            border="left"
            colored-border
            color="deep-purple accent-4"
            elevation="0"
            style="font-size: 1.2rem; font-weight: 600"
            >Address</v-alert
          >
          <v-row class="ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Address Line1 *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Address Line2 *"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="City *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Country *"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="State *"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Pin Code *"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-card flat class="mt-3">
          <v-alert
            border="left"
            colored-border
            color="deep-purple accent-4"
            elevation="0"
            style="font-size: 1.2rem; font-weight: 600"
            >Identification</v-alert
          >
          <v-row class="ma-0">
            <v-col cols="12" md="6">
              <v-text-field
                hide-details
                outlined
                dense
                label="Email *"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title>
            <v-file-input
              label="Photo (Headshot)"
              outlined
              dense
              show-size
              prepend-icon="mdi-camera"
              @change="previewImage"
            ></v-file-input>
            <v-card-text>
              <div class="image-preview" v-if="imageData.length > 0">
                <img class="preview" :src="imageData" />
              </div>
            </v-card-text>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    imageData: "",
  }),
  mounted() {
    this.$store.commit("setPageTitle", "New Application");
  },
  methods: {
    previewImage: function (event) {
      var input = event.target;
      console.log(event);
      if (input.files && input.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.imageData = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
  },
};
</script>

<style>
</style>